module.exports = __webpack_public_path__ + "kunniakierros-logo-fi.5f38fed6d688404349ed4cb3ab31ea36.png";


//////////////////
// WEBPACK FOOTER
// ./app/less/img/kunniakierros-logo-fi.png
// module id = 7
// module chunks = 0